"use strict";
//
//
//
//
//
//
'kiwi public';

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var _default = {
  props: ['network'],
  data: function data() {
    return {
      recaptchaSiteId: '',
      recaptchaResponse: '',
      showCaptcha: false
    };
  },
  created: function created() {
    var _this = this;

    var options = this.$state.settings.startupOptions;
    this.recaptchaSiteId = options.recaptchaSiteId || '';
    this.listen(this.$state, 'network.connecting', function (event) {
      event.network.ircClient.once('socket connected', function () {
        if (_this.recaptchaResponse) {
          event.network.ircClient.raw('CAPTCHA', _this.recaptchaResponse);
        }
      });
    });
    this.listen(this.$state, 'irc.raw.CAPTCHA', function (command, event, network) {
      if (network !== _this.network) {
        return;
      }

      if (event.params[0] === 'NEEDED') {
        _this.loadRecaptcha();
      }
    });
  },
  methods: {
    loadRecaptcha: function loadRecaptcha() {
      var _this2 = this;

      this.showCaptcha = true; // Recaptcha calls this callback once it's loaded and ready to be used

      window.recaptchaLoaded = function () {
        window.grecaptcha.render(_this2.$refs.captchacontainer, {
          sitekey: _this2.recaptchaSiteId,
          callback: _this2.recaptchaSuccess,
          'expired-callback': _this2.recaptchaExpired
        });
      };

      var scr = document.createElement('script');
      scr.src = 'https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=explicit';
      scr.defer = true;
      this.$el.appendChild(scr);
    },
    recaptchaSuccess: function recaptchaSuccess(response) {
      this.recaptchaResponse = response; // If we have a network instance already, send the captcha response

      if (this.network && this.network.state === 'connecting') {
        this.network.ircClient.raw('CAPTCHA', response);
      }

      this.showCaptcha = false;
    },
    recaptchaExpired: function recaptchaExpired() {
      this.recaptchaResponse = '';
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Captcha"]
window._kiwi_exports.components.Captcha = exports.default ? exports.default : exports;
